import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const CollectionIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 12 12" {...props}>
      <path d="M3.9595 8.6885L1.525 2H0.5C0.367 2 0.24 1.9475 0.1465 1.8535C0.0525 1.76 0 1.6325 0 1.5C0 1.224 0.2235 1 0.5 1H2.225L4.9595 8.5125C5.38 8.563 5.7545 8.7625 6.029 9.0565L11.658 7.008L12 7.9475L6.4755 9.958C6.4915 10.053 6.5 10.1505 6.5 10.25C6.5 11.216 5.7155 12 4.75 12C3.784 12 3 11.216 3 10.25C3 9.5685 3.3905 8.9775 3.9595 8.6885ZM4.75 9.594C5.112 9.594 5.406 9.888 5.406 10.25C5.406 10.612 5.112 10.9065 4.75 10.9065C4.3875 10.9065 4.0935 10.612 4.0935 10.25C4.0935 9.888 4.3875 9.594 4.75 9.594ZM11.407 6.338L5.698 8.416L4.33 4.657L10.039 2.579L11.407 6.338ZM7.052 4.7305L5.612 5.2545L6.296 7.134L10.1255 5.7405L9.4415 3.861L7.9915 4.3885L8.3335 5.328L7.394 5.6705L7.052 4.7305ZM8.388 2.648L4.159 4.187L3.1955 1.539L7.424 0L8.388 2.648ZM6.8265 1.2815L4.477 2.137L4.757 2.9055L7.106 2.0505L6.8265 1.2815Z" />
    </SvgIcon>
  );
});
